import { Button } from "@/components/ui/button";
import { CheckCircle, Star } from "lucide-react";
const HeroSection = () => {
  return <section id="home" className="hero-section relative min-h-screen flex items-center bg-gradient-to-br from-background via-background to-muted pt-20 sm:pt-24 lg:pt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <div className="flex">
                  {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-brand-gold-dark text-brand-gold-dark" />)}
                </div>
                <span className="text-sm text-muted-foreground font-medium">5.0 Rating • Connecticut's #1 Choice</span>
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                Professional <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">Cleaning</span> That Fits Your Routine
              </h1>
              
              <p className="text-xl text-muted-foreground leading-relaxed">
                Experience the difference with Connecticut's most trusted cleaning service. 
                We deliver exceptional results with personalized care, so you can focus on what matters most.
              </p>
            </div>

            {/* Key Benefits */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {["Licensed & Insured", "100% Satisfaction Guarantee", "Flexible Scheduling", "Experienced Team"].map(benefit => <div key={benefit} className="flex items-center space-x-3">
                  <CheckCircle className="h-5 w-5 text-accent flex-shrink-0" />
                  <span className="text-foreground font-medium">{benefit}</span>
                </div>)}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="hero" 
                size="xl" 
                className="flex-1 sm:flex-none touch-manipulation" 
                asChild
              >
                <a href="/estimate">
                  Get Your Free Estimate
                </a>
              </Button>
              <Button 
                variant="outline-blue" 
                size="xl" 
                className="flex-1 sm:flex-none touch-manipulation" 
                asChild
              >
                <a href="tel:+14752517156">
                  Call (475) 251-7156
                </a>
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center space-x-6 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span>Free Estimates Available</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span>No Contracts Required</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="/assets/hero-kitchen-clean.jpg" 
                alt="Professional cleaning service in Connecticut"
                width={612}
                height={600}
                loading="eager"
                fetchPriority="high"
                decoding="async"
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 612px"
                className="w-full h-[500px] lg:h-[600px] object-cover"
                style={{ aspectRatio: '612/600' }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent"></div>
            </div>
            
            {/* Floating testimonial card */}
            <div className="absolute -bottom-6 -left-6 bg-card p-6 rounded-xl shadow-lg border border-border max-w-xs">
              <div className="flex space-x-1 mb-2">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-brand-gold-dark text-brand-gold-dark" />)}
              </div>
              <p className="text-sm text-card-foreground font-medium mb-2">
                "Routine Cleaners transformed our home! Professional, reliable, and thorough."
              </p>
              <p className="text-xs text-muted-foreground">- Sarah M., Bethel CT</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;